import PageViewIcon from "@mui/icons-material/Pageview";
import { Box, Tooltip } from "@mui/material";
import { isAxiosError } from "axios";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import { tokenTemporaryService } from "../../../services/tokenTemorary.service";
import IconButton from "../../UI/IconButton";
import { getPixeonUrl, getTasyPixeonUrl } from "../../../services/exams.service";
import { IDicomAccesses } from "../../../models/exams";

const translationPath = "page.exams.";

interface IPixeonPacsProps {
  dicomAccesses: IDicomAccesses[];
}

const PixeonPacs = ({ dicomAccesses }: IPixeonPacsProps) => {
  const { t } = useTranslation();

  const isLogginTemporary = tokenTemporaryService.hasTemporaryAccessToken();

  const { sendRequest, loading } = useFetch(
    isLogginTemporary ? getTasyPixeonUrl : getPixeonUrl,
    {
      getErrorMessage: (error) =>
        isAxiosError(error) &&
        (error.code === "ECONNABORTED" ||
          error.message.toLowerCase().includes("timeout"))
          ? (t(translationPath + "pacsTimeoutError") as string)
          : undefined,
    },
  );

  const openPixeon = useCallback(async () => {
    const { data, success } = await sendRequest({
      Integrationid: dicomAccesses.find(
        (a) => a.integrationDescription === "PIXEON",
      )!.dicomAccess,
    });

    if (data && success) {
      window.open(data, "_blank");
    }
  }, [sendRequest, dicomAccesses]);

  const isLoading = loading;

  return (
    <>
      <Tooltip title={t(translationPath + "view")} placement="right">
        <Box>
          <IconButton
            size="small"
            loading={isLoading}
            onClick={openPixeon}
          >
            <PageViewIcon fontSize="small" />
          </IconButton>
        </Box>
      </Tooltip>
    </>
  );
};

export default memo(PixeonPacs);
